<style lang="less">

.qyvipkf {
    width: 100%;
    height: 100%;
    background: #F5F7FA;
    &-wrap {
        margin-top: 97px;
        text-align: center;
        color: #000000;
        .title {
            margin-bottom: 4px;
            font-size: 24px;
        }
        .tips {
            color: #666666;
        }
        .box {
            margin: 30px auto;
            padding: 20px 25px;
            width: fit-content;
            background: #FFFFFF;
            .text {
                margin-bottom: 4px;
                font-size: 20px;
            }
            .qrcode {
                margin-top: 8px;
                width: 230px;
                height: 230px;
            }
        }
    }
}

</style>
<template lang="html">
    <div class="qyvipkf">
        <div class="qyvipkf-wrap">
            <div class="title">{{qyVipData.chargeName}}服务已于{{qyVipData.expireAtLabel}}到期</div>
            <div class="tips">已无法使用班小二管理端统一发布全校信息及班级管理</div>
            <div class="box">
                <div class="text">需进行学校统一采购时</div>
                <div class="tips">↓请微信扫码联系下方班小二客服人员</div>
                <img class="qrcode" :src="qrcodeUrl" alt="客服二维码">
            </div>
        </div>
    </div>
</template>

<script>
import _common from '@js/common';
import _config from '@js/config';
import qt_storage from '@libs/qt/storage';

import vipmixins from '../mixins/vip';

export default {
    name: 'qyvipkf',
    mixins: [vipmixins],
    data() {
        return {
            qyVipData: '',
            qrcodeUrl: '',
        }
    },
    mounted: function () {
        const qyVipData = JSON.parse(qt_storage.sessionGet('qyVip_data'));
        this.qyVipData = qyVipData;
        this.queryQrcode();
    },
    methods: {
        queryQrcode () {
            this._postSign({
                url: this._config.SERVICE + '/extend/pro/schadm/order/vip/qr',
                params: {},
                success: (res) => {
                    if ('001' == res.resultCode) {
                        this.qrcodeUrl = res.data;
                    } else {
                        _common.tips(res.resultMsg);
                    }
                },
                fail: () => {
                    _common.tips('/extend/pro/schadm/order/vip/qr服务异常，请稍后重试')
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/vip/qyvipkf.vue